// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__ATxnv","slider":"Switch_slider__37-Jx","bigSwitch":"Switch_bigSwitch__L7dsu","smallSwitch":"Switch_smallSwitch__171mq","disabled":"Switch_disabled__2zAMp"};